export default __webpack_public_path__ + "static/media/black_gap.9497e96d.svg";